const multiColumnATC = () => {
    document.querySelectorAll('.column__btn .btn__atc').forEach(button => {
        button.addEventListener('click', function () {
            const url = this.getAttribute('data-url');
            const [path, query] = url.split('?');
            const [variantData] = path.split('/cart/').slice(1);
            const [variantId, quantity] = variantData.split(':');
            const params = new URLSearchParams(query);
            const discount = params.get('discount');
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id: variantId,
                    quantity: parseInt(quantity, 10),
                }),
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to add product to cart');
                }
                return response.json();
            })
            .then(data => {
                console.log(data);
            })
            .catch(error => {
                console.error(error);
            });
        });
    });
}
if(Shopify.designMode) {
    document.addEventListener("shopify:section:load", function(event) {
        multiColumnATC();
    });
};
document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelector('.section-columns')) {
        multiColumnATC();
    }
});

// The theme cart drawer is replaced by Rebuy Smart Cart, so the theme never
// rebuilds its own cart and the header count only changed on page load.
// Rebuy reports every cart change; pass the count on to the header.
document.addEventListener('rebuy:cart.change', function (event) {
    const cart = event.detail && event.detail.cart;
    const cartCount = cart && (cart.item_count !== undefined ? cart.item_count : cart.cart && cart.cart.item_count);
    if (typeof cartCount !== 'number') return;
    document.dispatchEvent(new CustomEvent('theme:cart:change', {
        bubbles: true,
        detail: { cartCount },
    }));
});

// Free shipping messaging: these products ship free on their own, so while one is in the cart the
// Rebuy Smart Cart bar's shipping tier counts as reached and the announcement bar shows its
// qualified message (snippets/announcement.liquid does the same on page load). This only changes
// what is displayed; the free shipping itself is set up in Shopify.
const freeShippingProductHandles = ['merry-bright-set'];
const shippingTierMinimums = new Map();

function syncFreeShippingBar() {
    const smartCart = window.Rebuy && window.Rebuy.SmartCart;
    const cart = window.Rebuy && window.Rebuy.Cart && window.Rebuy.Cart.cart;
    if (!cart) return;

    const shipsFree = (cart.items || []).some(item => freeShippingProductHandles.includes(item.handle));

    const tiers = smartCart && smartCart.progressBar && smartCart.progressBar.tiers;
    (tiers || []).filter(tier => tier.type === 'shipping').forEach(tier => {
        if (!shippingTierMinimums.has(tier.id)) shippingTierMinimums.set(tier.id, tier.minimum);
        // Rebuy divides by the minimum to size the bar, so use one cent rather than zero
        tier.minimum = shipsFree ? 0.01 : shippingTierMinimums.get(tier.id);
    });

    document.querySelectorAll('.announcement__bar [data-free-shipping="true"]').forEach(message => {
        const limit = Number(message.dataset.freeShippingLimit) * 100;
        message.classList.toggle('is-success', shipsFree || cart.total_price >= limit);

        const leftToSpend = message.querySelector('[data-left-to-spend]');
        if (leftToSpend && window.Shopify && Shopify.formatMoney) {
            leftToSpend.innerHTML = Shopify.formatMoney(Math.max(limit - cart.total_price, 0), theme.moneyFormat).replace('.00', '');
        }

        const graph = message.querySelector('[data-progress-graph]');
        if (graph && shipsFree) graph.style.setProperty('--stroke-dashoffset', '43.982297150257104');
    });
}

['rebuy:cart.ready', 'rebuy:cart.change', 'rebuy:smartcart.ready', 'rebuy:smartcart.show'].forEach(eventName => {
    document.addEventListener(eventName, syncFreeShippingBar);
});

if(document.querySelector("#all-natural-skincare-starter-set")) {
    setTimeout(() => {
        // Code to be executed after 2 seconds
        document.querySelector("#all-natural-skincare-starter-set .skincare-starter-set-4oz").remove();
    }, 2000);
}


// Custom product slider
function customProductSlider() {
    const productSectionWrapper = document.querySelector('.index-product .product__wrapper');
    if (productSectionWrapper && productSectionWrapper.classList.contains('product__wrapper--thumbnails')) {
        document.body.style.overflowX = 'hidden';
    }
}

// Upsell block custom variant dropdown select
class ExpandDropdown {
    constructor() {
        this.filterDropdowns = document.querySelectorAll('.prod-upsell__variants');
        this.activeMenu = null;
        this.init();
    }

    init() {
        if (this.filterDropdowns.length === 0) return;
        this.bindEvents();
    }

    bindEvents() {
        this.filterDropdowns.forEach(dropdown => {
            const btn = dropdown.querySelector('[data-variants-toggle]');
            const btnText = dropdown.querySelector('[data-variants-toggle] span');
            const filterMenu = dropdown.querySelector('.prod-upsell__variant-options');
            const options = dropdown.querySelectorAll('.prod-upsell__option');

            if (btn && filterMenu) {
                btn.addEventListener('click', (event) => this.toggleMenu(event, filterMenu));
            }

            options.forEach(option => {
                option.addEventListener('click', (event) => this.selectVariant(event, btnText, filterMenu, options));
            });
        });
        document.addEventListener('click', (event) => this.handleOutsideClick(event));
    }

    toggleMenu(event, filterMenu) {
        event.stopPropagation();
        if (this.activeMenu && this.activeMenu !== filterMenu) {
            this.activeMenu.classList.remove('dropdown-open');
        }
        if (filterMenu.classList.contains('dropdown-open')) {
            filterMenu.classList.remove('dropdown-open');
            this.activeMenu = null;
        } else {
            filterMenu.classList.add('dropdown-open');
            this.activeMenu = filterMenu;
        }
    }

    selectVariant(event, btnText, filterMenu, options) {
        const selectedOption = event.target.closest('.prod-upsell__option');
        const selectedTitle = selectedOption.getAttribute('data-variant-title');
        btnText.innerText = selectedTitle;
        options.forEach(option => option.classList.remove('active-prod-selection'));
        selectedOption.classList.add('active-prod-selection');
        filterMenu.classList.remove('dropdown-open');
        this.activeMenu = null;
    }

    handleOutsideClick(event) {
        if (this.activeMenu && !event.target.closest('[data-variants-toggle]')) {
            this.activeMenu.classList.remove('dropdown-open');
            this.activeMenu = null;
        }
    }
}

// Tabs toggle
const tabsToggle = () => {
    const tabCtrs = document.querySelectorAll('.column-item__content-tabs');
    tabCtrs.forEach(ctr => {
        const tabs = ctr.querySelectorAll('.column-item__tab');
        const tabsBody = ctr.querySelectorAll('.column-item__body');
        if(tabs[0]) {
            tabs[0].classList.add('tab-active');
        }
        if(tabsBody[0]) {
            tabsBody[0].classList.add('tab-active');
        }
        function activeClass(tabId) {
            tabsBody.forEach(body => {
                if (body.getAttribute('data-tab-id') === tabId) {
                    body.classList.add('tab-active');
                } else {
                    body.classList.remove('tab-active');
                }
            });
            tabs.forEach(tab => {
                if (tab.getAttribute('data-tab-id') === tabId) {
                    tab.classList.add('tab-active');
                } else {
                    tab.classList.remove('tab-active');
                }
            });
        }
        tabs.forEach(tab => {
            tab.addEventListener('click', function(event) {
                const tabId = event.currentTarget.getAttribute('data-tab-id');
                activeClass(tabId);
            });
        });
    });
};

document.addEventListener('shopify:section:load', () => {
    customProductSlider();
    new ExpandDropdown();
    tabsToggle();
});
document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelector('.index-product__custom-layout')) {
        customProductSlider();
    }
    if(document.querySelector('.product__upsell--custom')) {
        new ExpandDropdown();
        tabsToggle();
    }
});

// Afterpay move
document.addEventListener("DOMContentLoaded", function () {
    const observerTarget = document.body;

    const observer = new MutationObserver((mutationsList, observer) => {
        for (const mutation of mutationsList) {
            if (mutation.type === "childList") {
                const squarePlacement = document.querySelector("square-placement");
                const submitButtons = document.querySelector(".product__submit__buttons");

                if (squarePlacement && submitButtons) {
                    squarePlacement.remove();
                    submitButtons.insertAdjacentElement("afterend", squarePlacement);
                    observer.disconnect();
                    break;
                }
            }
        }
    });

    observer.observe(observerTarget, { childList: true, subtree: true });
});

function formatProductPrice() {
    const priceElements = document.querySelectorAll('.index-product .product__price [data-product-price]');
    
    function formatPrice(priceElement) {
        const price = priceElement.innerHTML;
        if (price) {
            const formattedPrice = price.replace(/\.\d+$/, '');
            if (priceElement.innerHTML !== formattedPrice) {
                priceElement.innerHTML = formattedPrice;
            }
            
            const strikeThroughPrice = priceElement.querySelector('s');
            if (strikeThroughPrice) {
                const formattedStrikePrice = strikeThroughPrice.innerHTML.replace(/\.\d+$/, '');
                if (strikeThroughPrice.innerHTML !== formattedStrikePrice) {
                    strikeThroughPrice.innerHTML = formattedStrikePrice;
                }
            }
        }
    }

    if (priceElements.length > 0) {
        priceElements.forEach(formatPrice);
    }

    const observerPrice = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'characterData' || mutation.type === 'childList') {
                const currentPriceElements = document.querySelectorAll('.index-product .product__price [data-product-price]');
                currentPriceElements.forEach(formatPrice);
            }
        }
    });

    const container = document.querySelector('.index-product') || document.body;
    observerPrice.observe(container, { 
        childList: true, 
        subtree: true, 
        characterData: true 
    });
    
    return observerPrice;
}
document.addEventListener("DOMContentLoaded", function() {
    if (document.querySelector('.index-product')) {
        formatProductPrice();
    }
});
document.addEventListener('shopify:section:load', () => {
    formatProductPrice();
});

// Afterpay styling
function applyAfterpayStyles() {
    const afterpayElement = document.querySelector('square-placement');
    if (afterpayElement && afterpayElement.shadowRoot) {
        const shadowRoot = afterpayElement.shadowRoot;
        if (shadowRoot.querySelector('.afterpay-paragraph')) {
            const style = document.createElement('style');
            style.textContent = `
                .afterpay-paragraph { 
                    margin-right: -25px !important;
                }
                .afterpay-paragraph .afterpay-main-text { 
                    color: #494541 !important;
                    font-size: 12px !important;
                    font-weight: 400 !important;
                    line-height: 200% !important;
                }
                .afterpay-paragraph strong {
                    font-weight: 400 !important;
                }
                .afterpay-paragraph .afterpay-link {
                    display: none !important;    
                }
                .afterpay-paragraph svg {
                    margin-left: -55px;
                }
                .afterpay-paragraph svg g path:nth-of-type(1),
                .afterpay-paragraph svg g path:nth-of-type(2) {
                    display: none !important;
                }
            `;
            shadowRoot.appendChild(style);
        }
    }
}

function observeAfterpayElement() {
        const afterpayObserver = new MutationObserver((mutationsList, observer) => {
            const afterpayElement = document.querySelector('square-placement');
            if (afterpayElement && afterpayElement.shadowRoot) {
                const shadowRoot = afterpayElement.shadowRoot;
                if (shadowRoot.querySelector('.afterpay-paragraph')) {
                    applyAfterpayStyles();
                }
            }
        });
        afterpayObserver.observe(document.body, { childList: true, subtree: true });
        const placementObserver = new MutationObserver(() => {
            const afterpayElement = document.querySelector('square-placement');
            if (afterpayElement && afterpayElement.shadowRoot) {
                const shadowRoot = afterpayElement.shadowRoot;
                if (shadowRoot.querySelector('.afterpay-paragraph')) {
                    applyAfterpayStyles();
                }
            }
        });
        placementObserver.observe(document.body, { childList: true, subtree: true });
}

document.addEventListener("DOMContentLoaded", function() {
    if (document.querySelector('.index-product')) {
        observeAfterpayElement();
    }
});

const hideAfterPay = () => {
    const rechargeBtns = document.querySelectorAll('.rtx-purchase-label');
    console.log(rechargeBtns)
    rechargeBtns.forEach((btn, index) => {
        if(index === 1) {
            btn.addEventListener('click', () => {
                document.querySelector('square-placement').classList.add('hide-square-placement')
            })
        }
        if(index === 0) {
            btn.addEventListener('click', () => {
                document.querySelector('square-placement').classList.remove('hide-square-placement')
            })
        }
    })
}
// hideAfterPay();

// Script for collection sidebar nav dropdown
const collectionSidebarNav = () => {
    const sidebarLinkList = document.querySelectorAll('.sidebar__item--linklist');
    sidebarLinkList.forEach(list => {
        const parent = list.querySelector('.parent-link');
        const dropdown = list.querySelector('.sidebar__item--dropdown');

        if(list.getAttribute('data-list-open') === "true") {
            dropdown.style.maxHeight = `${dropdown.scrollHeight}px`;
        }

        if (!parent) return;

        if (parent.dataset.listenerAdded === "true") return;

        parent.addEventListener('click', (e) => {
            let dataOpen = list.getAttribute('data-list-open');
            if (dataOpen === 'true') {
                list.setAttribute('data-list-open', 'false');
                dropdown.style.maxHeight = '0';
            } else {
                list.setAttribute('data-list-open', 'true');
                dropdown.style.maxHeight = `${dropdown.scrollHeight}px`;
            }
        });

        parent.dataset.listenerAdded = "true";
    });
};

document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector('.filter-group--nav')) {
        collectionSidebarNav();
    }
});

document.addEventListener('shopify:section:load', function () {
    collectionSidebarNav();
});

document.addEventListener('theme:filter:update', function () {
    collectionSidebarNav();
});

// Promo block height
function setHeightPromoBlocks() {
    const prodGridItems = document.querySelectorAll('.collection .product-item:not(.product-item.product-item--featured-image-double)');
    const promoBlocks = document.querySelectorAll('.collection .product-item.product-item--featured-image-double');

    if(promoBlocks.length === 0) return;

    let maxHeight = 0;
    prodGridItems.forEach(item => {
        item.style.height = 'auto';
        const itemHeight = item.offsetHeight;
        if (itemHeight > maxHeight) {
            maxHeight = itemHeight;
        }
    })
    promoBlocks.forEach(item => {
        item.style.height = `${maxHeight}px`;
    })
}
function checkHeightGridItems () {
    const promoBlocks = document.querySelectorAll('.collection .product-item.product-item--featured-image-double');
    if (window.innerWidth <= 989) {
        setHeightPromoBlocks();
    } else {
        promoBlocks.forEach(item => {
            item.style.height = 'auto';
        })
    }
}
document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector('.collection')) {
        checkHeightGridItems();
        window.addEventListener('resize', checkHeightGridItems);
    }
});
document.addEventListener('shopify:section:load', function () {
    if (document.querySelector('.collection')) {
        checkHeightGridItems();
        window.addEventListener('resize', checkHeightGridItems);
    }
});

  const reviewsDiv = document.querySelector(".yotpo-sr-bottom-line-text");
  if (reviewsDiv) {
    reviewsDiv.innerHTML = reviewsDiv.innerHTML.replace(/Reviews/gi, "").trim();
  }


// Discount product price logic
// Resolves the discount percent for a product title: tier percent if the
// product is listed in a tier (first matching tier wins), otherwise the
// default percent. Returns null when not on sale (excluded, 0% tier, or
// sale disabled).
const getDiscountPercent = (productTitle) => {
    if(!theme.settings.enablePriceDiscount) return null;
    if(!productTitle) return null;

    const title = productTitle.toLowerCase().trim();

    const excludeArr = (theme.settings.excludeFromDiscount || '').split(',').map(t => t.toLowerCase().trim());
    if(excludeArr.includes(title)) return null;

    let percent = theme.settings.discountAmount;
    const tiers = theme.settings.discountTiers || [];
    for(const tier of tiers) {
        const products = (tier.products || '').split(',').map(t => t.toLowerCase().trim()).filter(Boolean);
        if(products.includes(title)) {
            percent = tier.amount;
            break;
        }
    }

    if(!percent || percent <= 0) return null;
    return percent;
};

const initializeDiscountLogic = (container, productTitle) => {
    if(!theme.settings.enablePriceDiscount) return;
    if(!container || !productTitle) return;

    if(container.dataset.discountInitialized) return;
    container.dataset.discountInitialized = 'true';

    const discountPercent = getDiscountPercent(productTitle);
    const enableDiscountLogic = discountPercent !== null;

    if(enableDiscountLogic) {
        // const rtxSubWidget = container.querySelector('.rtx-subscription__widget');
        // if(rtxSubWidget) {
        //     const subOneTimeBtn = rtxSubWidget.querySelector('.rtx-purchase-label--one-time');
        //     const subBtn = rtxSubWidget.querySelector('.rtx-purchase-label--subscription');
        //     const pdpDiscountWrapper = container.querySelectorAll('[data-pdp-discount-wrapper]:not(.rtx-subscription [data-pdp-discount-wrapper])');
        //     const dataPriceEl = container.querySelectorAll('[data-product-price-custom]');

        //     if(!subBtn?.dataset.listenerAdded) {
        //         subBtn.addEventListener('click', () => {
        //             pdpDiscountWrapper.forEach(wrapper => {
        //                 wrapper.style.display = 'none';
        //             })
        //             dataPriceEl.forEach(el => {
        //                 el.style.visibility = 'visible';
        //                 el.style.width = 'auto';
        //                 el.style.height = 'auto';
        //             })
        //         });
        //         subBtn.dataset.listenerAdded = 'true';
        //     }

        //     if(!subOneTimeBtn?.dataset.listenerAdded) {
        //         subOneTimeBtn.addEventListener('click', () => {
        //             pdpDiscountWrapper.forEach(wrapper => {
        //                 wrapper.style.display = 'flex';
        //             })
        //             dataPriceEl.forEach(el => {
        //                 el.style.visibility = 'hidden';
        //                 el.style.width = '0';
        //                 el.style.height = '0';
        //             })
        //         });
        //         subOneTimeBtn.dataset.listenerAdded = 'true';
        //     }
        // }

        if(!container.dataset.variantListenerAdded) {
            container.addEventListener('theme:variant:change', (event) => {
                const subOneTimeBtn = container.querySelector('.rtx-purchase-label--one-time');
                const pdpDiscountWrapper = container.querySelectorAll('[data-pdp-discount-wrapper]');
                
                const discountAmount = (100 - discountPercent) / 100;

                const originalPrice = (event.detail.variant.price / 100);
                let variantPrice = originalPrice.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
                let discountPrice = (originalPrice * discountAmount).toLocaleString('en-US', {style: 'currency', currency: 'USD'});

                variantPrice = variantPrice.replace(/\.00$/, '');
                discountPrice = discountPrice.replace(/\.00$/, '');

                if(subOneTimeBtn && !subOneTimeBtn.classList.contains('is-selected')) {
                    subOneTimeBtn.click();
                }

                pdpDiscountWrapper.forEach(wrapper => {
                    const oneTimeEl = wrapper.querySelector('[data-one-time-price]');
                    const discountEl = wrapper.querySelector('[data-discount-price]');
                    if(oneTimeEl) oneTimeEl.innerText = variantPrice;
                    if(discountEl) discountEl.innerText = discountPrice;
                })
            });
            container.dataset.variantListenerAdded = 'true';
        }
    }
}

const initProductPageDiscount = () => {
    const container = document.querySelector('[data-section-type="product"]');
    if(!container) return;
    
    const productTitle = theme.settings.productTitle;
    initializeDiscountLogic(container, productTitle);
}

const initQuickAddDiscount = () => {
    const modals = document.querySelectorAll('[data-quick-add-modal]:not([data-discount-initialized])');
    
    modals.forEach(modal => {
        const productTitleEl = modal.querySelector('.product__title');
        if(!productTitleEl) return;
        
        const productTitle = productTitleEl.innerText;
        initializeDiscountLogic(modal, productTitle);
    });
}

document.addEventListener("DOMContentLoaded", initProductPageDiscount);
document.addEventListener('shopify:section:load', initProductPageDiscount);
document.addEventListener('theme:quick-add:open', initQuickAddDiscount);


const quickAddOverride = () => {
    const quickAddCtr = document.querySelector('.quick-add-override');
    if(!quickAddCtr) return;

    const pageBtns = document.querySelectorAll('.main-content .btn, .main-content button:not(.quick-add-override button):not(button.flickity-button):not(.review__video-play-btn)');
    const quickAddBtn = quickAddCtr.querySelector('.quick-add__button');

    pageBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.stopImmediatePropagation();
            e.preventDefault();
            quickAddBtn.click();
        }, true)
    })
}
document.addEventListener("DOMContentLoaded", quickAddOverride);


const reviewsVideoBtn = () => {
    const reviewsSections = document.querySelectorAll('.reviews--section');
    if (!reviewsSections.length) return;

    reviewsSections.forEach(section => {
        const wrappers = section.querySelectorAll('.review__video-wrapper');
        
        wrappers.forEach(wrapper => {
            const video = wrapper.querySelector('.review__video');
            const playBtn = wrapper.querySelector('.review__video-play-btn');
            
            if (!video || !playBtn) return;

            if (!video.poster || video.poster.includes('data:image')) {
                video.addEventListener('play', () => {
                    if (!wrapper.classList.contains('is-playing')) {
                        video.pause();
                        video.currentTime = 0;
                    }
                }, { once: true });
            }
            
            playBtn.addEventListener('click', () => {
                video.muted = false;
                video.play();
                wrapper.classList.add('is-playing');
            });
            
            video.addEventListener('click', () => {
                if (wrapper.classList.contains('is-playing')) {
                    video.pause();
                }
            });
            
            video.addEventListener('pause', () => {
                wrapper.classList.remove('is-playing');
            });
            
            video.addEventListener('ended', () => {
                wrapper.classList.remove('is-playing');
            });
        });
    });

};

document.addEventListener("DOMContentLoaded", reviewsVideoBtn);
document.addEventListener('shopify:section:load', reviewsVideoBtn);

// New PDP: show the sticky Add to Cart bar on mobile only after the
// in-form Add to Cart button has scrolled out of view
const newPdpStickyATC = () => {
    if (!document.body.classList.contains('template-product-new-pdp')) return;

    const buttons = document.querySelector('.index-product .product__submit--sticky .product__submit__buttons');
    if (!buttons || buttons.dataset.stickyAtcInit) return;
    buttons.dataset.stickyAtcInit = 'true';

    // Zero-height marker at the button's spot in the form; it also holds the
    // button's height open while the button is fixed, so content doesn't jump
    const sentinel = document.createElement('div');
    buttons.parentNode.insertBefore(sentinel, buttons.nextSibling);

    const mobile = window.matchMedia('(max-width: 749px)');

    const observer = new IntersectionObserver(([entry]) => {
        const scrolledPast = entry.boundingClientRect.top < 0;
        if (mobile.matches && !entry.isIntersecting && scrolledPast) {
            sentinel.style.height = buttons.offsetHeight + 'px';
            buttons.classList.add('sticky-atc-active');
        } else {
            buttons.classList.remove('sticky-atc-active');
            sentinel.style.height = '';
        }
    });
    observer.observe(sentinel);

    mobile.addEventListener('change', () => {
        if (!mobile.matches) {
            buttons.classList.remove('sticky-atc-active');
            sentinel.style.height = '';
        }
    });
};

document.addEventListener('DOMContentLoaded', newPdpStickyATC);
document.addEventListener('shopify:section:load', newPdpStickyATC);

// Complete Contour Set (snippets/contour-set-selector.liquid): the set swatches and the
// bundle's shade dropdowns (snippets/product-buttons.liquid) both write into the selector's
// hidden option inputs, then let the theme's variant logic take over. Picking a set fills the
// dropdowns with its shades ("Build Your Own" starts on Pure / Pink Frost); picking a shade
// selects the matching set, or "Build Your Own".
function contourSetParts(element) {
    const section = element.closest('[data-section-type="product"]') || element.closest('.shopify-section') || document;
    const selector = section.querySelector('[data-contour-set]');
    return {
        selector,
        optionInputs: selector ? Array.from(selector.querySelectorAll('[data-contour-set-input]')) : [],
        dropdowns: Array.from(section.querySelectorAll('[data-contour-custom-option]')),
    };
}

function updateContourOptions(optionInputs, valueFor) {
    optionInputs.forEach((input) => {
        const value = valueFor(input.dataset.contourSetInput);
        if (value !== null && value !== undefined) input.value = value;
    });

    // One change event is enough: the theme reads every option input on each change
    if (optionInputs.length) {
        optionInputs[optionInputs.length - 1].dispatchEvent(new Event('change', { bubbles: true }));
    }
}

function updateContourSummary(selector, setName, optionInputs) {
    const label = selector.querySelector('[data-contour-set-label]');
    if (label) label.textContent = setName;

    // Concealer is the first option and cheek tint the second (see the selector snippet)
    const includes = selector.querySelector('[data-contour-set-includes]');
    if (includes && optionInputs.length >= 2) {
        includes.textContent = 'Includes: ' + optionInputs[0].value + ' Concealer, ' + optionInputs[1].value + ' Cheek Tint, Bronzer';
    }
}

// Show a value in a bundle shade dropdown without going through a click
function setContourDropdown(input, value) {
    input.value = value;
    const popout = input.closest('popout-select');
    if (!popout) return;

    const toggleText = popout.querySelector('[data-popout-toggle-text]');
    if (toggleText) toggleText.textContent = value;

    const toggleSwatch = popout.querySelector('[data-bundle-swatch]');
    if (toggleSwatch) {
        const handle = value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
        toggleSwatch.style.setProperty('--swatch', 'var(--' + handle + ')');
    }

    popout.querySelectorAll('[data-popout-option]').forEach((option) => {
        const isActive = option.dataset.value === value;
        option.parentElement.classList.toggle('is-active', isActive);
        if (isActive) option.setAttribute('aria-current', 'true');
        else option.removeAttribute('aria-current');
    });
}

document.addEventListener('change', (event) => {
    const setInput = event.target.closest('[data-contour-set-option]');
    if (!setInput) return;

    const { selector, optionInputs, dropdowns } = contourSetParts(setInput);

    // Each set, and "Build Your Own", carries its starting shades as data-option-N
    updateContourOptions(optionInputs, (position) => setInput.getAttribute('data-option-' + position));
    dropdowns.forEach((dropdown) => {
        const value = setInput.getAttribute('data-option-' + dropdown.dataset.contourCustomOption);
        if (value !== null) setContourDropdown(dropdown, value);
    });

    updateContourSummary(selector, setInput.value, optionInputs);
});

// The dropdown fires a non-bubbling change on its input, so listen in the capture phase
document.addEventListener('change', (event) => {
    const dropdown = event.target.closest && event.target.closest('[data-contour-custom-option]');
    if (!dropdown) return;

    const { selector, optionInputs } = contourSetParts(dropdown);
    if (!selector) return;

    updateContourOptions(optionInputs, (position) => (position === dropdown.dataset.contourCustomOption ? dropdown.value : null));

    // Select the set these shades make up, otherwise "Build Your Own"
    const sets = Array.from(selector.querySelectorAll('[data-contour-set-option]'));
    const matchingSet = sets.find((set) => !set.hasAttribute('data-contour-custom') &&
        optionInputs.every((input) => set.getAttribute('data-option-' + input.dataset.contourSetInput) === input.value));
    const activeSet = matchingSet || sets.find((set) => set.hasAttribute('data-contour-custom'));
    if (activeSet) activeSet.checked = true;

    updateContourSummary(selector, activeSet ? activeSet.value : '', optionInputs);
}, true);

// Product gallery arrows for the mobile swipe strip
function initGalleryArrows() {
    document.querySelectorAll('.product__images').forEach(images => {
        const slides = images.querySelector('[data-product-slideshow]');
        const prev = images.querySelector('[data-gallery-arrow="prev"]');
        const next = images.querySelector('[data-gallery-arrow="next"]');
        if (!slides || !prev || !next || images.dataset.galleryArrows) return;
        images.dataset.galleryArrows = 'true';

        // Distance between two slides (slide width + gap); falls back to the visible width
        const step = () => {
            const [first, second] = slides.querySelectorAll('.product__slide');
            return second ? second.offsetLeft - first.offsetLeft : slides.clientWidth;
        };
        // Only one arrow shows at a time: next until the last slide, then prev
        const update = () => {
            const atEnd = slides.scrollLeft + slides.clientWidth >= slides.scrollWidth - 2;
            prev.disabled = !atEnd;
            next.disabled = atEnd;
        };

        prev.addEventListener('click', () => slides.scrollBy({ left: -step(), behavior: 'smooth' }));
        next.addEventListener('click', () => slides.scrollBy({ left: step(), behavior: 'smooth' }));
        slides.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
    });
}

document.addEventListener('DOMContentLoaded', initGalleryArrows);
document.addEventListener('shopify:section:load', initGalleryArrows);

// Timed preorder (snippets/product-buttons.liquid): while the preorder note is on the page the
// Add to Cart button reads "Preorder Now". At the cutoff the button text goes back to normal and
// the note is hidden, including on pages that were opened before the cutoff.
function initTimedPreorder() {
    document.querySelectorAll('[data-preorder-note]').forEach(note => {
        if (note.dataset.preorderInit) return;
        note.dataset.preorderInit = 'true';

        const until = Number(note.dataset.preorderUntil) * 1000;
        const preorderText = note.dataset.preorderText;
        const normalText = theme.strings.addToCart;
        const container = note.closest('[data-section-type="product"]') || note.closest('form') || document;
        const buttonTexts = container.querySelectorAll('[data-add-to-cart-text]');

        const swap = (from, to) => buttonTexts.forEach(el => {
            if (el.textContent.trim() === from) el.textContent = to;
        });

        // The theme rewrites the button text on every variant change, so keep it on the preorder text
        const observer = new MutationObserver(() => swap(normalText, preorderText));

        const end = () => {
            observer.disconnect();
            swap(preorderText, normalText);
            note.hidden = true;
        };

        if (Date.now() >= until) return end();

        swap(normalText, preorderText);
        buttonTexts.forEach(el => observer.observe(el, { childList: true, characterData: true, subtree: true }));
        setTimeout(end, until - Date.now());
    });
}

document.addEventListener('DOMContentLoaded', initTimedPreorder);
document.addEventListener('shopify:section:load', initTimedPreorder);
